import { createSelector } from 'reselect';

import { FLAMINGO_RESERVED_REFS } from '@mode/shared/util-js';

import { AppState } from '@mode/legacy/types-app-state';
import { fromChartSelectors } from '@mode/charts/domain';
import { getEncodedChartInNormalizedChartArray, getChartState } from '~/lib/chart-helpers';
import { ChartState } from '@mode/legacy/types-app-state';
import { fromSwitchViewSelectors } from '@mode/switch-views/domain';

export namespace ChartDesignerSelectors {
  export function createPagingSelector(chartToken: string) {
    return (state: AppState) => state.vizDesigner.tablePaging[chartToken];
  }

  export const getExplorationTableOffset = createSelector(
    (state: AppState) => state.vizDesigner.tablePaging[FLAMINGO_RESERVED_REFS.Exploration],
    (paging) => {
      if (paging) {
        return paging.offset;
      }

      return 0;
    }
  );

  export const getSelectedTableOffset = createSelector(
    (state: AppState) => state.vizDesigner.tablePaging[state.chart.selectedToken],
    (paging) => {
      if (paging) {
        return paging.offset;
      }

      return 0;
    }
  );

  export function createPagingOffsetSelector(chartToken: string) {
    return createSelector(createPagingSelector(chartToken), (paging) => {
      if (paging) {
        return paging.offset;
      }

      return 0;
    });
  }

  export const getSelectedTableColumnSearch = createSelector(
    (state: AppState) => state.vizDesigner.tableColumnSearch[state.chart.selectedToken],
    (columnSearchModel) => (columnSearchModel ? columnSearchModel : {})
  );

  export function createColumnSearchFilterSelector(chartToken: string) {
    return createSelector(
      (state: AppState) => state.vizDesigner.tableColumnSearch[chartToken],
      (columnSearchModel) => (columnSearchModel ? columnSearchModel : {})
    );
  }

  export const getActiveTableColumn = (state: AppState) => state.vizDesigner.activeTableColumn;

  export const getPanes = (state: AppState) => state.vizDesigner.panes;

  export const getTablePanes = (state: AppState) => state.vizDesigner.tablePanes;

  // GF version of getChartState
  export const getChartStateGf = createSelector(
    fromChartSelectors.selectedToken,
    fromChartSelectors.selectChartState,
    fromSwitchViewSelectors.getModel,
    (token, charts, model): ChartState => {
      const chart = getEncodedChartInNormalizedChartArray(charts, token);

      if (chart && charts.tokens.has(token)) {
        return getChartState(chart, model, chart.queryToken);
      }
    }
  );
}
